import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState as C_RootState } from '@Redux/common/store';
import domainByEnv from '@utils/domainByEnv';
import { ArrowUp, ArrowRight } from '@components/Common/Icons';
import cN from 'classnames';
import { useMediaQuery } from 'react-responsive';
import { timeTransform } from '@utils/utils';
// import parse from 'html-react-parser';
import styles from '../style.module.scss';

interface I_Props {
    dailyItem: any;
    toggleLightBox: (reqDayID: number, reqPOIID: string) => void;
}

const DayAttractions: React.FC<I_Props> = ({ dailyItem, toggleLightBox }) => {
    const { curPage } = useSelector((store: C_RootState) => store.pageReducer);
    const [openedDay, setOpenedDay] = useState<number[]>([]);
    const attractionsList = dailyItem.AttractionsList;
    // const defaultImg = `${domainByEnv()}/_webassets/lightspeed/subsitebundles/common/imgs/default16-9.jpg`;

    const toggleSites = (Day: number) => {
        if (openedDay.includes(Day)) {
            const arr: number[] = [...openedDay];
            setOpenedDay(removeByValue(arr, Day));
            return;
        }
        setOpenedDay([...openedDay, Day]);
    };

    //filter
    const removeByValue = (arr: number[], val: number): number[] => {
        for (let i = 0; i < arr.length; i) {
            if (arr[i] == val) {
                arr.splice(i, 1);
                break;
            }
        }
        return arr;
    };

    const isTheDay = openedDay.includes(dailyItem.Day);
    return (
        <div className={styles.sitesWrapper}>
            {!isTheDay &&
                attractionsList.length > 0 &&
                attractionsList.map((attractionsItem: any) => (
                    <div
                        className={cN(styles.sites, {
                            [`${styles.unCursor}`]:
                                curPage == 'print' ||
                                (!attractionsItem.Introduction && !attractionsItem.ImgUrl),
                        })}
                        key={attractionsItem.AttractionsID}
                        onClick={() => {
                            !attractionsItem.Introduction && !attractionsItem.ImgUrl
                                ? null
                                : toggleLightBox(dailyItem.DayID, attractionsItem.AttractionsID);
                        }}
                    >
                        <div className={styles.siteContent}>
                            <div className={styles.content}>
                                <div
                                    className={cN(styles.titleWrapper, {
                                        [`${styles.printModeSiteTitle}`]: curPage === 'print',
                                    })}
                                >
                                    {attractionsItem.ArrivalTime && (
                                        <span className={styles.title}>
                                            {attractionsItem.ArrivalTime}
                                        </span>
                                    )}
                                    <span className={styles.title}>{attractionsItem.Name}</span>
                                    {attractionsItem.LabelList &&
                                        attractionsItem.LabelList.length > 0 &&
                                        attractionsItem.LabelList.map((item: any, idx: any) => (
                                            <span
                                                key={attractionsItem.AttractionsID + idx}
                                                className={styles.label}
                                            >
                                                {item}
                                            </span>
                                        ))}
                                </div>
                                {attractionsItem.Introduction && (
                                    <div
                                        className={styles.introduction}
                                        dangerouslySetInnerHTML={{
                                            __html: attractionsItem.Introduction,
                                        }}
                                    />
                                )}

                                {attractionsItem.Memo && (
                                    <div className={styles.memo}>{attractionsItem.Memo}</div>
                                )}
                                {attractionsItem.ResidenceTime && (
                                    <div className={styles.time}>
                                        <span>
                                            停留時間約
                                            {timeTransform(attractionsItem.ResidenceTime)}
                                        </span>
                                    </div>
                                )}
                            </div>
                            {attractionsItem.ImgUrl && (
                                <div className={styles.imgWrapper}>
                                    <img src={attractionsItem.ImgUrl} alt="景點圖片" />
                                </div>
                            )}
                            {curPage !== 'print' &&
                                (!attractionsItem.Introduction && !attractionsItem.ImgUrl ? null : (
                                    <ArrowRight fill="#222" />
                                ))}
                        </div>
                    </div>
                ))}
            {attractionsList.length > 0 && curPage !== 'print' && (
                <div className={styles.toggle} onClick={() => toggleSites(dailyItem.Day)}>
                    {!isTheDay ? '收起' : '展開'}
                    行程內容
                    <ArrowUp fill="#669" className={cN(isTheDay && styles.down)} />
                </div>
            )}
        </div>
    );
};

export default DayAttractions;
